<div class="select-container flags-autocomplete-control" [class.readonly]="readonly">
  <div class="header">
    <div class="label">{{ label }}</div>

    <div>
      <app-form-switch-button
        [text]="switchBtnText"
        (switchForm)="onClickBtn()"
      />
    </div>
  </div>

  <div
    ngbDropdown
    class="dropdown input-container"
    [open]="dropdownOpen"
    (openChange)="onDropdownChange($event, flagsSearchInput)"
  >
    <div
      class="input-wrapper"
      [class]="{
        opened: dropdownOpen,
        error: displayValidationError,
        selected: value,
      }"
    >
      <button
        ngbDropdownToggle
        type="button"
        class="input bg-white"
        [disabled]="isDisabled || disabled || readonly"
      >
        <span class="d-flex align-items-center gap-8">
          <span [class]="value?.flagClass"></span>
          <span>{{ value?.countryCode }}</span>
        </span>

        <span class="icon ic-select-20"></span>
      </button>
    </div>

    <div ngbDropdownMenu class="dropdown-menu pt-0">
      <input
        #flagsSearchInput
        tabindex="0"
        class="input search-input"
        type="text"
        [formControl]="searchControl"
        [placeholder]="placeholder"
        (keydown)="dropdownOpen = true"
        (keydown.escape)="dropdownOpen = false"
        (blur)="onBlur()"
      >

      @for (option of filteredOptionsSignal(); track option; let index = $index) {
        <button
          ngbDropdownItem
          type="button"
          class="dropdown-button"
          [disabled]="isDisabled || disabled || readonly"
          [class.selected]="option.label === value?.label && option.value === value?.value"
          (click)="selectOption(option, index)"
        >
          <span>
            <span [class]="option.flagClass"></span>
            <span class="ms-2 label">{{ option.label }}</span>
          </span>

          <span class="icon ic-checkmark-circle-16"></span>
        </button>
      }

      @if (searchControl.value?.length && !filteredOptionsSignal().length) {
        <div class="dropdown-button">No options found for "{{ searchControl.value }}".</div>
      }

      @if (!options.length) {
        <div class="dropdown-button">No options.</div>
      }
    </div>
  </div>

  @if (displayValidationError) {
    <app-validation-error [customErrors]="customErrors"></app-validation-error>
  }
</div>
